import CityPageTemplate from "../city-template/CityPageTemplate";
import { augustaMeConfig } from "./data";

export default function AugustaMePage() {
  return <CityPageTemplate config={augustaMeConfig} />;
}